"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWarningTimeout = exports.usePrevious = exports.useInterval = exports.useInfiniteScrollWithRefCallback = exports.useFileHandler = exports.useError = void 0;
var _react = require("react");
var _reactI18next = require("react-i18next");
var _constants = require("./constants");
var _helpers = require("./helpers");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* istanbul ignore next */
var useWarningTimeout = exports.useWarningTimeout = function useWarningTimeout(active, timeout) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    warning = _useState2[0],
    setWarning = _useState2[1];
  (0, _react.useEffect)(function () {
    if (warning) return;
    if (active && timeout !== null) {
      console.log('timeout: ', timeout);
      if (timeout <= 0) {
        setWarning(true);
      } else {
        var timer = setTimeout(function () {
          console.log('triggered');
          setWarning(true);
        }, timeout * 1000);
        return function () {
          return clearTimeout(timer);
        };
      }
    } else {
      setWarning(false);
    }
  }, [active, timeout, warning]);
  return warning;
};
var useInterval = exports.useInterval = function useInterval(callback, delay) {
  var savedCallback = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    savedCallback.current = callback;
  }, [callback]);
  (0, _react.useEffect)(function () {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }
  }, [delay]);
};
var usePrevious = exports.usePrevious = function usePrevious(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
};
var useInfiniteScrollWithRefCallback = exports.useInfiniteScrollWithRefCallback = function useInfiniteScrollWithRefCallback(callback, disabled, setMemoryScrollTop, setMemoryScrollHeight, refDates, refDateSticky) {
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFetching = _useState4[0],
    setIsFetching = _useState4[1];
  var scrolledTo = function scrolledTo(ref) {
    if (disabled && !isFetching) {
      setIsFetching(true);
      setMemoryScrollTop(true);
      setMemoryScrollHeight(ref.scrollHeight);
    }
  };
  var scrolledRef = (0, _react.useRef)(scrolledTo);
  (0, _react.useEffect)(function () {
    scrolledRef.current = scrolledTo;
  });
  var ref = (0, _react.useRef)(null);
  var setRef = (0, _react.useCallback)(function (node) {
    function isScrolling(e) {
      var topLabel = refDateSticky.current;
      var dateLabels = refDates.current;
      var currentLabel = null;
      dateLabels.forEach(function (dateLabel) {
        if (dateLabel != null && e.currentTarget.scrollTop >= dateLabel.offsetTop) {
          currentLabel = dateLabel;
        }
      });
      if (currentLabel) {
        topLabel.style.opacity = '1';
        topLabel.innerText = currentLabel.innerText;
        topLabel.style.height = 'fit-content';
      } else {
        if (topLabel) {
          topLabel.style.opacity = '0';
          topLabel.style.height = '0px';
        }
      }
      if (e.currentTarget.scrollTop + e.currentTarget.clientHeight === e.currentTarget.scrollHeight) setMemoryScrollTop(false);
      if (e.currentTarget.scrollTop !== 0 || isFetching) return;
      scrolledRef.current(e.currentTarget);
    }
    if (ref.current) {
      ref.current.removeEventListener('scroll', isScrolling);
    }
    if (node) {
      node.addEventListener('scroll', isScrolling);
    }
    ref.current = node;
  }, []);
  (0, _react.useEffect)(function () {
    if (!isFetching || !disabled) {
      if (!isFetching) setMemoryScrollTop(false);
      return;
    }
    callback();
  }, [isFetching, disabled]);
  return [setRef, isFetching, setIsFetching, ref.current];
};
var useError = exports.useError = function useError() {
  var _useState5 = (0, _react.useState)({
      show: false,
      title: '',
      content: ''
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var showError = function showError(title, message) {
    return setError({
      show: true,
      title: title,
      content: message
    });
  };
  var toggleError = function toggleError() {
    return setError(function (e) {
      return _objectSpread(_objectSpread({}, e), {}, {
        show: !e.show
      });
    });
  };
  return [error, showError, toggleError];
};
var useFileHandler = exports.useFileHandler = function useFileHandler(mediaType, maxImgToSend, onError) {
  var _useTranslation = (0, _reactI18next.useTranslation)('chat'),
    t = _useTranslation.t;
  var getFiles = function getFiles(fileList) {
    var files = Array.from(fileList);
    var preview = [];
    if (_constants.TABS.CHAT === mediaType) {
      if (Object.values(files).filter(function (f) {
        return (0, _helpers.isNotFileAllowed)(f);
      }).length > 0) {
        onError(files.length > 1 ? t('errorFormat.attachErrorTitleMultiple') : t('errorFormat.attachErrorTitleSingle'), t('errorFormat.attachErrorMessage'));
        return;
      }
      if (Object.values(files).filter(function (f) {
        return f.size / 1000000 > 16;
      }).length > 0) {
        onError(files.length > 1 ? t('errorSize.attachErrorTitleMultiple') : t('errorSize.attachErrorTitleSingle'), files.length > 1 ? t('errorSize.attachErrorMultiple') : t('errorSize.attachErrorSingle'));
        return;
      }
      preview = files.slice(0, maxImgToSend).map(function (f) {
        var url = window.URL.createObjectURL(f);
        return {
          currentFile: f,
          name: f.name,
          size: f.size,
          preview: {
            type: 'image',
            url: url
          },
          type: 'image',
          urllocal: url
        };
      });
    } else {
      var filtered = files.filter(function (f) {
        return !(0, _helpers.isUnsafeFile)(f);
      }).filter(function (f) {
        return f.size / 1000000 <= 64;
      });
      if (Object.values(files).filter(function (f) {
        return (0, _helpers.isUnsafeFile)(f);
      }).length > 0) {
        onError(files.length > 1 ? t('errorFormat.attachErrorTitleMultiple') : t('errorFormat.attachErrorTitleSingle'), t('errorFormat.attachErrorMessageWhatsapp'));
        throw new Error("File Type Not Supported");
      }
      if (Object.values(files).filter(function (f) {
        return f.size / 1000000 > 64;
      }).length > 0) {
        onError(files.length > 1 ? t('errorSize.attachErrorTitleMultiple') : t('errorSize.attachErrorTitleSingle'), files.length > 1 ? t('errorSize.attachErrorMultipleWhatsapp') : t('errorSize.attachErrorSingleWhatsapp'));
        throw new Error("File Size Not Allowed");
      }
      preview = filtered.map(function (f) {
        var temp = (0, _helpers.mimeTypeLeft)(f.type);
        var type = temp !== 'image' && temp !== 'video' && temp !== 'audio' ? 'file' : temp;
        var url = window.URL.createObjectURL(f);
        f.preview = {
          type: type,
          url: url
        };
        // f.type = type;
        f.urllocal = url;
        return f;
      });
    }
    return preview;
  };
  return getFiles;
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/utils/hooks.js
// module id = 168
// module chunks = 0